import $ from 'domtastic'
import Masonry from 'masonry-layout'

import { getMQ } from '@utils/utils'
import BaseComponent from './_BaseComponent'


/* Wall
----------------------------------------------------------------------------------------------------*/

export default class Wall extends BaseComponent {

    constructor($el, namespace) {
        super('Wall', $el, namespace)


        this.on()
    }

    bindProperties() {
        this.throttleRelayout = false
        this.$refs.ctn = $(this.$el[0].closest('.js-Wall-ctn'))
        this.$refs.gut = this.$refs.ctn?.find('.js-Wall-gut') || this.$el.find('.js-Wall-gut')
        this.$refs.col = this.$refs.ctn?.find('.js-Wall-col') || this.$el.find('.js-Wall-col')

        this.MQ = getMQ(this.$el.attr('data-wall-start-at'), '<=')
        this.verticalOrder = this.$el.attr('data-wall-order') === 'vertical'

        this.setSizes()
        this.buildWall()
    }


    bindHandlers() {
        this.resizeHandler = () => { this.onResize() }
    }


    bindEvents() {
        this.addListeners(
            [document, 'layoutChange', this.resizeHandler],
        )
    }


    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        const prevMQ = this.MQ
        this.MQ = getMQ(this.$el.attr('data-wall-start-at'), '<=')

        if (!this.MQ) {
            if (this.masonry && prevMQ !== this.MQ) {
                this.$refs.brick.css('margin-bottom', '')
                this.masonry.destroy()

                this.masonry = null

                return
            }
        }

        this.setSizes()
        this.buildWall()
    }



    /* Actions
    --------------------------------------------------------- */


    setSizes() {
        const { isMobile, gutWidth } = APP.Layout

        let margin = isMobile ? '' : `${gutWidth}px`
        margin = this.MQ ? `${gutWidth}px` : margin

        if ('brick' in this.$refs) {
            this.$refs.brick.css('margin-bottom', margin)
        }


        if (this.masonry && this.throttleRelayout) {
            this.masonry.layout()
        }
    }


    buildWall() {
        if (this.masonry || this.MQ) {
            return
        }
        const { col, gut } = this.$refs


        this.masonry = new Masonry(this.$el[0], {
            horizontalOrder    : !this.verticalOrder,
            resize             : !this.throttleRelayout,
            transitionDuration : 0,
            itemSelector       : '.js-Wall-brick',
            columnWidth        : col[0],
            gutter             : gut[0],
        })

        this.masonry.on('layoutComplete', () => {
            this.$utils.doc.trigger('contentChange')
        })

        setTimeout(() => {
            this.masonry.layout()
        }, 100)
    }




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



